import { render } from "./BaseButton.vue?vue&type=template&id=7afb25af&scoped=true"
const script = {}

import "./BaseButton.vue?vue&type=style&index=0&id=7afb25af&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7afb25af"]])

export default __exports__